import { FormListEntity, FormListEntityApi } from './entity';

export const normalizeFormListData = (
  form: FormListEntityApi
): FormListEntity => {
  return {
    startDatetime: form.start_datetime ? new Date(form.start_datetime) : null,
    status: form.status,
    finishDatetime: form.finish_datetime
      ? new Date(form.finish_datetime)
      : null,
    id: form.id,
    name: form.name,
  };
};
